import { render, staticRenderFns } from "./SfColorPicker.vue?vue&type=template&id=a01db664"
import script from "./SfColorPicker.vue?vue&type=script&lang=js"
export * from "./SfColorPicker.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  var style0 = require("./SfColorPicker.vue?vue&type=style&index=0&id=a01db664&prod&lang=scss")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  "4862ee20"
  
)

export default component.exports